/**
 * BY_DIFFICULTIES catalog images — static lookup by templateKey only.
 * Generated from testGroupAndTestConfig.v1.ts via scripts/generate-catalog-image-config-difficulties.mjs
 * Do not edit by hand unless you re-run the generator after changing allocation images.
 */
import type { CatalogStaticImageRef } from './catalogImageConfigByTopics.v1';

export type { CatalogStaticImageRef };

/** Band parent groups: Soft / Medium / Hard covers. */
export const BY_DIFFICULTIES_GROUP_IMAGE_CONFIG_V1: Record<string, CatalogStaticImageRef> = {
  'difficulty.hard': {
    imageStoragePath: 'images/catalog/difficulty.hard.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fdifficulty.hard.jpg?alt=media&token=5c52f886-54a8-4b51-9b29-89b48c40cb8e',
  },
  'difficulty.medium': {
    imageStoragePath: 'images/catalog/difficulty.medium.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fdifficulty.medium.jpg?alt=media&token=083bb717-3ab5-42f5-8378-b3861f937bb6',
  },
  'difficulty.soft': {
    imageStoragePath: 'images/catalog/difficulty.soft.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fdifficulty.soft.jpg?alt=media&token=348d2f79-cd10-4012-a8d0-245754933f6d',
  },
};

/** Child tests: one topic slot image per row. */
export const BY_DIFFICULTIES_TEST_IMAGE_CONFIG_V1: Record<string, CatalogStaticImageRef> = {
  'difficulty.hard.topic.drinking-driving.slot.1': {
    imageStoragePath: 'images/catalog/drinking-driving-1.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fdrinking-driving-1.jpg?alt=media&token=3a1bb696-fdb6-4e08-adf4-5e43de3dbb19',
  },
  'difficulty.hard.topic.driver-license.slot.1': {
    imageStoragePath: 'images/catalog/driver-license-2.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fdriver-license-2.jpg?alt=media&token=d58efbdf-99b0-44c8-a513-89e6d3ed82d1',
  },
  'difficulty.hard.topic.driving.slot.1': {
    imageStoragePath: 'images/catalog/driving-5.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fdriving-5.jpg?alt=media&token=35d681cc-d1a0-4cdd-875a-c0264f9b6fb1',
  },
  'difficulty.hard.topic.emergency-on-road.slot.1': {
    imageStoragePath: 'images/catalog/emergency-on-road-2.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Femergency-on-road-2.jpg?alt=media&token=3e6b3fa5-8975-406b-8de1-2231929f49f1',
  },
  'difficulty.hard.topic.fines-and-limits.slot.1': {
    imageStoragePath: 'images/catalog/fines-and-limits-1.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Ffines-and-limits-1.jpg?alt=media&token=ba3c0eec-4c2a-4cf1-9d15-4b4c5d253b5d',
  },
  'difficulty.hard.topic.freeways.slot.1': {
    imageStoragePath: 'images/catalog/freeways-1.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Ffreeways-1.jpg?alt=media&token=acf99eaa-b711-4254-8ec2-a7a719970601',
  },
  'difficulty.hard.topic.railroad-crossings.slot.1': {
    imageStoragePath: 'images/catalog/railroad-crossings-2.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Frailroad-crossings-2.jpg?alt=media&token=bf140e94-fe38-447d-bd3b-ae7c11433f4b',
  },
  'difficulty.hard.topic.road-signs.slot.1': {
    imageStoragePath: 'images/catalog/road-signs-5.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Froad-signs-5.jpg?alt=media&token=784fadc0-50c7-4f76-b008-06bbda604d28',
  },
  'difficulty.hard.topic.road-signs.slot.2': {
    imageStoragePath: 'images/catalog/road-signs-5.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Froad-signs-5.jpg?alt=media&token=784fadc0-50c7-4f76-b008-06bbda604d28',
  },
  'difficulty.hard.topic.road-work.slot.1': {
    imageStoragePath: 'images/catalog/road-work-1.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Froad-work-1.jpg?alt=media&token=12dbdfe9-3c88-4310-9224-a728a822542e',
  },
  'difficulty.hard.topic.roundabouts.slot.1': {
    imageStoragePath: 'images/catalog/roundabouts-2.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Froundabouts-2.jpg?alt=media&token=70f11ff6-739d-418a-8ace-0635b941d3cd',
  },
  'difficulty.hard.topic.sharing-road.slot.1': {
    imageStoragePath: 'images/catalog/sharing-road-3.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fsharing-road-3.jpg?alt=media&token=3d0fef27-b4bc-4125-ab75-05fafadd1414',
  },
  'difficulty.hard.topic.sharing-road.slot.2': {
    imageStoragePath: 'images/catalog/sharing-road-2.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fsharing-road-2.jpg?alt=media&token=0c7ee03f-0b1a-4a66-b9ff-fd778079d439',
  },
  'difficulty.hard.topic.traffic-regulations.slot.1': {
    imageStoragePath: 'images/catalog/traffic-regulations-5.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Ftraffic-regulations-5.jpg?alt=media&token=53f9bd8b-77ca-4905-be5e-ec8db5da3691',
  },
  'difficulty.hard.topic.use-of-lights.slot.1': {
    imageStoragePath: 'images/catalog/use-of-lights-2.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fuse-of-lights-2.jpg?alt=media&token=5e6c8c6c-9225-47f0-a4fe-04cc017b92ec',
  },
  'difficulty.hard.topic.weather-conditions.slot.1': {
    imageStoragePath: 'images/catalog/weather-conditions-1.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fweather-conditions-1.jpg?alt=media&token=6e2ef2ad-1292-47db-8637-dce7631b75e7',
  },
  'difficulty.medium.topic.braking.slot.1': {
    imageStoragePath: 'images/catalog/braking-2.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fbraking-2.jpg?alt=media&token=16da5f6c-873d-43d5-93ab-59463328966a',
  },
  'difficulty.medium.topic.drinking-driving.slot.1': {
    imageStoragePath: 'images/catalog/drinking-driving-1.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fdrinking-driving-1.jpg?alt=media&token=3a1bb696-fdb6-4e08-adf4-5e43de3dbb19',
  },
  'difficulty.medium.topic.driver-license.slot.1': {
    imageStoragePath: 'images/catalog/driver-license-2.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fdriver-license-2.jpg?alt=media&token=d58efbdf-99b0-44c8-a513-89e6d3ed82d1',
  },
  'difficulty.medium.topic.driving.slot.1': {
    imageStoragePath: 'images/catalog/driving-3.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fdriving-3.jpg?alt=media&token=b3fd5999-18c5-4a71-9676-1e83f98be95a',
  },
  'difficulty.medium.topic.driving.slot.2': {
    imageStoragePath: 'images/catalog/driving-4.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fdriving-4.jpg?alt=media&token=ac313495-68e6-435c-a412-9b99b9c0dc72',
  },
  'difficulty.medium.topic.emergency-on-road.slot.1': {
    imageStoragePath: 'images/catalog/emergency-on-road-1.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Femergency-on-road-1.jpg?alt=media&token=b00f953d-730a-4268-b491-98eaf1feb747',
  },
  'difficulty.medium.topic.freeways.slot.1': {
    imageStoragePath: 'images/catalog/freeways-1.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Ffreeways-1.jpg?alt=media&token=acf99eaa-b711-4254-8ec2-a7a719970601',
  },
  'difficulty.medium.topic.maneuvers-signaling.slot.1': {
    imageStoragePath: 'images/catalog/maneuvers-signaling-2.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fmaneuvers-signaling-2.jpg?alt=media&token=1bbb4e9d-77a9-4db0-b45c-95319352bffb',
  },
  'difficulty.medium.topic.parking-regulations.slot.1': {
    imageStoragePath: 'images/catalog/parking-regulations-2.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fparking-regulations-2.jpg?alt=media&token=38f36b2c-798d-4b39-a8da-81bb05312eb3',
  },
  'difficulty.medium.topic.passing.slot.1': {
    imageStoragePath: 'images/catalog/passing-2.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fpassing-2.jpg?alt=media&token=fe83ed69-daa6-416c-8336-e8ad820ed267',
  },
  'difficulty.medium.topic.priority-on-road.slot.1': {
    imageStoragePath: 'images/catalog/priority-on-road-2.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fpriority-on-road-2.jpg?alt=media&token=c5e14479-e5cb-4d6a-84ee-974dea3ca8d7',
  },
  'difficulty.medium.topic.railroad-crossings.slot.1': {
    imageStoragePath: 'images/catalog/railroad-crossings-2.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Frailroad-crossings-2.jpg?alt=media&token=bf140e94-fe38-447d-bd3b-ae7c11433f4b',
  },
  'difficulty.medium.topic.road-markings.slot.1': {
    imageStoragePath: 'images/catalog/road-markings-1.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Froad-markings-1.jpg?alt=media&token=9f9a3a80-ceb7-4811-a6a4-ac5dd4fc9ece',
  },
  'difficulty.medium.topic.road-signs.slot.1': {
    imageStoragePath: 'images/catalog/road-signs-3.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Froad-signs-3.jpg?alt=media&token=92c19d0a-cd16-4f88-8d48-d05e58473e1b',
  },
  'difficulty.medium.topic.road-signs.slot.2': {
    imageStoragePath: 'images/catalog/road-signs-4.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Froad-signs-4.jpg?alt=media&token=1c451abc-bbf7-4589-8cb7-b3400e68557d',
  },
  'difficulty.medium.topic.road-work.slot.1': {
    imageStoragePath: 'images/catalog/road-work-1.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Froad-work-1.jpg?alt=media&token=12dbdfe9-3c88-4310-9224-a728a822542e',
  },
  'difficulty.medium.topic.roundabouts.slot.1': {
    imageStoragePath: 'images/catalog/roundabouts-2.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Froundabouts-2.jpg?alt=media&token=70f11ff6-739d-418a-8ace-0635b941d3cd',
  },
  'difficulty.medium.topic.sharing-school-bus.slot.1': {
    imageStoragePath: 'images/catalog/sharing-school-bus-1.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fsharing-school-bus-1.jpg?alt=media&token=6b3962b0-6d35-461b-938f-cbd64bd3cdf7',
  },
  'difficulty.medium.topic.traffic-regulations.slot.1': {
    imageStoragePath: 'images/catalog/traffic-regulations-3.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Ftraffic-regulations-3.jpg?alt=media&token=36e5ee2c-c183-4082-ade3-e47dfa74e8ca',
  },
  'difficulty.medium.topic.traffic-regulations.slot.2': {
    imageStoragePath: 'images/catalog/traffic-regulations-4.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Ftraffic-regulations-4.jpg?alt=media&token=4fa147ca-d957-44c4-9485-42c1a6464396',
  },
  'difficulty.medium.topic.use-of-lights.slot.1': {
    imageStoragePath: 'images/catalog/use-of-lights-2.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fuse-of-lights-2.jpg?alt=media&token=5e6c8c6c-9225-47f0-a4fe-04cc017b92ec',
  },
  'difficulty.medium.topic.weather-conditions.slot.1': {
    imageStoragePath: 'images/catalog/weather-conditions-1.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fweather-conditions-1.jpg?alt=media&token=6e2ef2ad-1292-47db-8637-dce7631b75e7',
  },
  'difficulty.soft.topic.braking.slot.1': {
    imageStoragePath: 'images/catalog/braking-1.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fbraking-1.jpg?alt=media&token=a15173af-47dd-4ef3-a703-696ab809d0e2',
  },
  'difficulty.soft.topic.driving.slot.1': {
    imageStoragePath: 'images/catalog/driving-1.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fdriving-1.jpg?alt=media&token=301a0086-72d7-4e34-8411-1302a43c0f6e',
  },
  'difficulty.soft.topic.maneuvers-signaling.slot.1': {
    imageStoragePath: 'images/catalog/maneuvers-signaling-1.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fmaneuvers-signaling-1.jpg?alt=media&token=14ffeb48-8762-4f24-8b51-bd67756c33ad',
  },
  'difficulty.soft.topic.parking-regulations.slot.1': {
    imageStoragePath: 'images/catalog/parking-regulations-1.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fparking-regulations-1.jpg?alt=media&token=9b18ddcb-377f-4d01-a591-f594f9f9e3ea',
  },
  'difficulty.soft.topic.passing.slot.1': {
    imageStoragePath: 'images/catalog/passing-1.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fpassing-1.jpg?alt=media&token=d7c299dc-c8c9-456f-828a-cd4a6cb44125',
  },
  'difficulty.soft.topic.priority-on-road.slot.1': {
    imageStoragePath: 'images/catalog/priority-on-road-1.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fpriority-on-road-1.jpg?alt=media&token=d42d945c-02ff-4c7a-b526-1501707dd401',
  },
  'difficulty.soft.topic.road-markings.slot.1': {
    imageStoragePath: 'images/catalog/road-markings-1.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Froad-markings-1.jpg?alt=media&token=9f9a3a80-ceb7-4811-a6a4-ac5dd4fc9ece',
  },
  'difficulty.soft.topic.road-signs.slot.1': {
    imageStoragePath: 'images/catalog/road-signs-1.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Froad-signs-1.jpg?alt=media&token=3ca7b20b-e08f-4521-bfe0-1807eb84746c',
  },
  'difficulty.soft.topic.road-signs.slot.2': {
    imageStoragePath: 'images/catalog/road-signs-2.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Froad-signs-2.jpg?alt=media&token=4613aae8-6d84-466d-af45-bd3884a16f2b',
  },
  'difficulty.soft.topic.sharing-pedestrians.slot.1': {
    imageStoragePath: 'images/catalog/sharing-pedestrians-1.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Fsharing-pedestrians-1.jpg?alt=media&token=edd39ad7-5147-42e1-b2dd-1007a9c1e424',
  },
  'difficulty.soft.topic.traffic-regulations.slot.1': {
    imageStoragePath: 'images/catalog/traffic-regulations-1.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Ftraffic-regulations-1.jpg?alt=media&token=2deb0040-3685-4cbd-b388-c8185669bd85',
  },
  'difficulty.soft.topic.traffic-regulations.slot.2': {
    imageStoragePath: 'images/catalog/traffic-regulations-2.jpg',
    imageUrl:
      'https://firebasestorage.googleapis.com/v0/b/vehiwheelprod/o/images%2Fcatalog%2Ftraffic-regulations-2.jpg?alt=media&token=b987c373-0569-43e3-b3f3-a6a66d9bf589',
  },
};
